import { render, staticRenderFns } from "./use_via.vue?vue&type=template&id=23fcf6db&scoped=true&"
import script from "./use_via.vue?vue&type=script&lang=js&"
export * from "./use_via.vue?vue&type=script&lang=js&"
import style0 from "./use_via.vue?vue&type=style&index=0&id=23fcf6db&scoped=true&lang=css&"
import style1 from "./use_via.vue?vue&type=style&index=1&id=23fcf6db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fcf6db",
  null
  
)

export default component.exports